import React from 'react';
import {
  LayoutDashboard,
  Users,
  Calendar,
  Settings,
  Network,
  Square,
  Map,
  type LucideIcon as LucideIconType,
} from 'lucide-react';

interface LucideIconProps {
  iconName: string;
  className?: string;
  size?: number | string;
}

const iconMap: Record<string, LucideIconType> = {
  map: Map,
  sitemap: Map,
  network: Network,
  dashboard: LayoutDashboard,
  users: Users,
  calendar: Calendar,
  settings: Settings,
};

const LucideIcon: React.FC<LucideIconProps> = ({
  iconName,
  className = '',
  size = 16,
}) => {
  const IconComponent = iconMap[iconName.toLowerCase()] || Square;
  return <IconComponent className={className} size={size} />;
};

export default LucideIcon;
